// utils/smoothScroll.ts
export const smoothScrollTo = (targetY: number, duration: number = 600) => {
    const startY = window.scrollY;
    const diff = targetY - startY;
    let startTime: number | null = null;
  
    const easeInOutQuad = (t: number): number =>
        t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  
    const step = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const time = timestamp - startTime;
        const percent = Math.min(time / duration, 1);
        const eased = easeInOutQuad(percent);
        window.scrollTo(0, startY + diff * eased);
    
        if (time < duration) {
            window.requestAnimationFrame(step);
        }
    };
  
    window.requestAnimationFrame(step);
};
  